import { Button, Modal } from '@evaneos/b2b-ui/legacy';
import { FormattedMessage, useIntl } from 'react-intl';

import { ContractId } from '../../../../../../resources/contract/types';

type Props = {
    isOpen: boolean;
    close: () => void;
    contractId?: ContractId;
    instalmentId?: string;
    submit: () => void;
};

export const DeleteInstalmentModal = ({ isOpen, close, submit }: Props): JSX.Element => {
    const intl = useIntl();

    return (
        <Modal
            isOpen={isOpen}
            title={intl.formatMessage({
                id: 'contract.payment_schedule.instalment.delete.title',
            })}
            onRequestClose={close}
            mainButton={
                <Button danger onClick={submit} data-testid="modal.delete.instalment">
                    <FormattedMessage id="contract.payment_schedule.instalment.delete.submit" />
                </Button>
            }
            secondaryButton={
                <Button
                    priority="secondary"
                    onClick={close}
                    data-testid="dossier-information-cancel-traveller-name"
                >
                    <FormattedMessage id="form.cancel" />
                </Button>
            }
        >
            <p>
                <FormattedMessage id="contract.payment_schedule.instalment.delete.message" />
            </p>
        </Modal>
    );
};
